export default __webpack_public_path__ + "static/media/317.51ded94d.jpg";